export default __webpack_public_path__ + "static/media/Nestletick.52292347.png";